import React from "react";
import { Colours } from "../../../utils/colours";

export const Pencil: React.FC<DogsTrust.IconProps> = ({
	height = "30px",
	width = "30px",
	fill = Colours.MIDNIGHT,
	...props
}) => {
	return (
		<svg
			{...props}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 24 24"
			height={height}
			width={width}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill={fill}
				d="M2.6875 17.9219C2.82812 17.4531 3.0625 16.9844 3.34375 16.6094V16.5625H3.39062C3.48438 16.4219 3.625 16.2812 3.71875 16.1875L17.9688 1.9375C19.1406 0.765625 21.0625 0.765625 22.2344 1.9375L24.0625 3.76562C24.2031 3.90625 24.3438 4.09375 24.4375 4.23438C25.2344 5.40625 25.0938 7 24.0625 8.03125L9.8125 22.2812C9.76562 22.3281 9.67188 22.375 9.625 22.4688C9.57812 22.5156 9.48438 22.5625 9.4375 22.6094V22.6562H9.39062C9.01562 22.9375 8.54688 23.1719 8.07812 23.3125L4.42188 24.3906L2.40625 25C2.03125 25.0938 1.60938 25 1.32812 24.6719C1 24.3906 0.90625 23.9688 1.04688 23.5938L1.60938 21.5781L2.6875 17.9219ZM18.9531 9.95312L16.0469 7.04688L7.32812 15.7656L7.89062 18.1094L10.2344 18.6719L18.9531 9.95312ZM5.54688 17.8281L4.98438 18.2031C4.9375 18.2969 4.89062 18.4375 4.84375 18.5781L4.51562 19.6562L3.76562 22.2344L6.34375 21.4844L7.42188 21.1562C7.5625 21.1094 7.70312 21.0625 7.79688 21.0156L8.17188 20.5L6.71875 20.125C6.29688 20.0312 5.96875 19.7031 5.875 19.2812L5.54688 17.8281ZM15.7656 11.2656L11.2656 15.7656C10.9844 16.0469 10.4688 16.0469 10.1875 15.7656C9.90625 15.4844 9.90625 15.0156 10.1875 14.7344L14.6875 10.2344C14.9688 9.90625 15.4844 9.90625 15.7656 10.2344C16.0469 10.5156 16.0469 10.9844 15.7656 11.2656Z"
				fill="#222222"
			/>
		</svg>
	);
};

export default Pencil;
